import type { ResultOf } from 'gql.tada'
import type { CURRENT_COMPANY_NOTIFICATION_SETTINGS_QUERY } from '@/modules/companies/queries'

export type CompanyWithNotificationSettings = ResultOf<
  typeof CURRENT_COMPANY_NOTIFICATION_SETTINGS_QUERY
>['currentCompany']

type CompanyWithNotificationSettingsName =
  NonNullable<CompanyWithNotificationSettings>['notificationSettings'][number]['name']

export const NotificationSettings: Record<
  CompanyWithNotificationSettingsName,
  string
> = {
  USER_REGISTRATION: 'userRegistration',
  RESET_PASSWORD: 'resetPassword',
  USER_DOCUMENT: 'userDocument',
  ISSUE_CREATED: 'issueCreated',
  ISSUE_CLOSED: 'issueClosed',
  ABSENCE_CREATED: 'absenceCreated',
  ABSENCE_STATUS_CHANGED: 'absenceStatusChanged',
  ABSENCE_REQUEST_CHANGED: 'absenceRequestChanged',
  FORUM_THREAD_CREATED: 'forumThreadCreated',
  FORUM_POST_CREATED: 'forumPostCreated',
  DRIVER_CARD_WILL_EXPIRE: 'driverCardWillExpire',
  USER_EXPORT_READY: 'userExportReady',
  VEHICLE_EXPIRATION: 'vehicleExpiration',
  VEHICLE_DOCUMENT: 'vehicleDocument',
  NEW_INFRINGEMENT: 'newInfringement',
  INFRINGEMENT_LEADER_COMMENT: 'infringementLeaderComment',
  INFRINGEMENT_EXPLANATION_CHANGED: 'infringementExplanationChanged',
  ISSUE_REMINDER: 'issueReminder',
  PLANNER_CALENDAR_EVENT_CHANGE: 'plannerCalendarEventChange',
  ISSUE_REOPENED: 'issueReopened',
  ISSUE_ARCHIVED: 'issueArchived',
  ISSUE_UNARCHIVED: 'issueUnarchived',
  WORK_PERIOD_APPROVAL: 'workPeriodApproval',

  FLEET_GEOFENCE_ZONE_ENTRY: '',
  FLEET_GEOFENCE_ZONE_EXIT: '',
}

export type NotificationSettingsNames = keyof typeof NotificationSettings
